import { AboutCompanyResponse, GeneralFeedbackResponse, InterviewState, JobDetailsResponse, PersonalInfoResponse, ReasonForLeavingResponse, WagesAndBenefitsResponse } from 'src/store/state/interviewState';
import { Interview, InterviewDraft } from 'exit-interview.shared/models/dataModels/interview';
import { createAction, createReducer } from '@reduxjs/toolkit';

import { HttpMethod } from 'exit-interview.shared/constants/httpMethod';
import { callApi } from 'src/utility/api';
import { createApiThunk } from 'src/types/reduxHelpers';

export const postInterviewResponseByInterviewId = createApiThunk<void, { token?: string, interview?: InterviewState, employeeReferenceId?: number }>('/interviewResponse//:employeeReferenceId', async ({ token, interview, employeeReferenceId }, thunkApi) => {
    const response = await callApi<void>(`/interviewResponse/employeeReferenceId/${employeeReferenceId}`, HttpMethod.POST, {
        token: token,
        employeeReferenceId: employeeReferenceId,
        interview: interview,
    }
    );
    return response.data;
});

export const createInterview = createApiThunk<Interview, InterviewDraft>('/interview/createInterview', async (interviewDraft, thunkApi) => {
    const response = await callApi<Interview>('/interview/', HttpMethod.POST, {
        ...interviewDraft,
    });

    return response.data;
});

export const setPersonalInfo = createAction<PersonalInfoResponse>('/interview/setPersonalInfo');
export const setReasonsForLeaving = createAction<ReasonForLeavingResponse>('/interview/setReasonsForLeaving');
export const setJobDetails = createAction<JobDetailsResponse>('/interview/setJobDetails');
export const setAboutCompany = createAction<AboutCompanyResponse>('/interview/setAboutCompany');
export const setWagesAndBenefits = createAction<WagesAndBenefitsResponse>('/interview/setWagesAndBenefits');
export const setGeneralFeedback = createAction<GeneralFeedbackResponse>('/interview/setGeneralFeedback');
export const resetInterviewState = createAction<void>('/interview/reset');

const initialState: InterviewState = {};

export const interviewReducer = createReducer(initialState, (builder) => {
    builder
        .addCase(setPersonalInfo, (state, action) => {
            state.personalInfo = {
                ...action.payload,
            };
        })
        .addCase(setReasonsForLeaving, (state, action) => {
            state.reasonsForLeaving = {
                reasons: [
                    ...action.payload.reasons,
                ],
            };
        })
        .addCase(setJobDetails, (state, action) => {
            state.jobDetails = {
                ...action.payload,
            };
        })
        .addCase(setAboutCompany, (state, action) => {
            state.aboutCompany = {
                ...action.payload,
            };
        })
        .addCase(setWagesAndBenefits, (state, action) => {
            state.wagesAndBenefits = {
                ...action.payload,
            };
        }).addCase(setGeneralFeedback, (state, action) => {
            state.generalFeedback = {
                ...action.payload,
            };
        })
        .addCase(resetInterviewState, (state, action) => {
            // Never reassign the state object directly, i.e. state = initialState
            // Return the new value directly instead.
            // https://redux-toolkit.js.org/usage/immer-reducers#resetting-and-replacing-state
            return initialState;
        });
});